import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AuthService } from '@core/service/auth.service';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';

@Component({
  selector: 'app-benef-detail',
  imports: [CommonModule],
  templateUrl: './benef-detail.component.html',
  styleUrl: './benef-detail.component.scss'
})
export class BenefDetailComponent {
  @ViewChild('imageInput') imageInput!: ElementRef<HTMLInputElement>;

  @Input() itemBeneficiare: any = {};
  @Input() isLoading = false;
  @Input() searchAttempted = false;
  @Input() canEditProfile = false;

  imageLoading = false;

  constructor(
    private restClient: RestClientService,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {}

  isBeneficiaryDataComplete(): boolean {
    return !!(this.itemBeneficiare?.nom && this.itemBeneficiare?.prenom);
  }

  getInitials(): string {
    if (!this.itemBeneficiare?.nom && !this.itemBeneficiare?.prenom) return 'B';
    const nom = this.itemBeneficiare.nom || '';
    const prenom = this.itemBeneficiare.prenom || '';
    return `${prenom.charAt(0)}${nom.charAt(0)}`.toUpperCase();
  }

  getPlaceholderImage(): string {
    return `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xMDAgODBDMTEwLjQ5NCA4MCAxMTkgNzEuNDkzNCAxMTkgNjFDMTE5IDUwLjUwNjYgMTEwLjQ5NCA0MiAxMDAgNDJDODkuNTA2NiA0MiA4MSA1MC41MDY2IDgxIDYxQzgxIDcxLjQ5MzQgODkuNTA2NiA4MCAxMDAgODBaIiBmaWxsPSIjOUNBM0FGIi8+CjxwYXRoIGQ9Ik0xMDAgOTBDNzUuMTQ3MiA5MCA1NSAxMTAuMTQ3IDU1IDEzNVYxNTBIMTQ1VjEzNUMxNDUgMTEwLjE0NyAxMjQuODUzIDkwIDEwMCA5MFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+`;
  }

  onImageError(event: any): void {
    event.target.src = this.getPlaceholderImage();
    this.imageLoading = false;
  }

  onImageLoad(): void {
    this.imageLoading = false;
  }

  openImageUpload(): void {
    if (this.canEditProfile && this.itemBeneficiare?.id) {
      this.imageInput?.nativeElement?.click();
    } else {
      this.utilities.showSweetNotification(
        "Vous n'avez pas les permissions pour modifier cette image",
        'warning'
      );
    }
  }

  onImageSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      this.utilities.showSweetNotification('Veuillez sélectionner un fichier image valide', 'error');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      this.utilities.showSweetNotification("La taille de l'image ne doit pas dépasser 2MB", 'error');
      return;
    }

    this.imageLoading = true;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.itemBeneficiare.image_url = e.target.result;
    };
    reader.readAsDataURL(file);

    this.uploadImageToServer(file);
  }

  private uploadImageToServer(file: File): void {
    if (!this.itemBeneficiare?.id) {
      this.utilities.showSweetNotification('Aucun bénéficiaire sélectionné', 'error');
      this.imageLoading = false;
      return;
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('beneficiary_id', this.itemBeneficiare.id.toString());

    this.restClient.post('beneficiaire/upload-image', formData).subscribe({
      next: (response: any) => {
        this.imageLoading = false;
        if (response && !response.hasError) {
          this.itemBeneficiare.image_url = response.image_url;
          this.utilities.showSweetNotification('Image mise à jour avec succès', 'success');
        } else {
          this.utilities.showSweetNotification(
            response?.status?.message || "Erreur lors de l'upload", 'error'
          );
        }
      },
      error: () => {
        this.imageLoading = false;
        this.utilities.showSweetNotification("Erreur lors de l'upload de l'image", 'error');
      }
    });
  }
}
